export enum DescricaoCalendario{
  //Padrao
  EdicaoOrdinaria,
  EdicaoExtra,

  //Tela de calendário
  PublicaoNormal,
  SemPublicacao,
  SemPublicacaoDiasEspecificos
}
